// `/distributors/$id/sync-events` — sub-tab карточки тенанта (PA-12, D17 §2.3).
//
// View-only журнал sync_event с pre-applied distributorId. AdminShell, TabBar
// и `redirectIfNotPlatformAdmin` живут в layout-route'е
// (`distributors.$id.tsx`); child наследует гард через TanStack Router
// `beforeLoad`.
import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { SyncEventsScreen } from '../features/sync-events/SyncEventsScreen'

export const Route = createFileRoute('/distributors/$id/sync-events')({
  component: DistributorSyncEventsTab,
})

function DistributorSyncEventsTab() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    return (
      <div style={{ padding: 24, color: 'var(--color-text-secondary)' }}>
        Некорректный идентификатор дистрибьютора в URL.
      </div>
    )
  }
  return (
    <RequireAuth>
      <SyncEventsScreen lockedDistributorId={numericId} />
    </RequireAuth>
  )
}
